<template>
  <div class="page rec-page">
    <xh-header />

    <div class="container-width" v-if="loaded">
      <div class="rc-bread">
        <span class="mouse" @click="back">
          <i class="el-icon-arrow-left"></i> 返回课程
        </span>
      </div>

      <div v-if="!records.length" class="empty-block">
        暂无答题记录
        <div style="margin-top:14px;">
          <el-button type="primary" size="small" @click="goExam">前往答题</el-button>
        </div>
      </div>

      <div v-else class="rc-layout">
        <!-- 历史侧栏 -->
        <div class="rc-side">
          <div class="rc-side-head">考试历史 ({{ records.length }})</div>
          <ul class="rc-list">
            <li
              v-for="(r, idx) in records"
              :key="r.record.id"
              :class="{ 'on': r.record.id === activeId }"
              @click="select(idx)">
              <div class="rl-row">
                <span class="rl-no">第 {{ records.length - idx }} 次</span>
                <el-tag size="mini" :type="r.record.passFlag === 1 ? 'success' : 'danger'">
                  {{ r.record.passFlag === 1 ? '通过' : '未通过' }}
                </el-tag>
              </div>
              <div class="rl-time">{{ r.record.submitTime ? formatDate(Date.parse(r.record.submitTime), 'YYYY-mm-dd hh:ii') : '--' }}</div>
              <div class="rl-score">得分 <b>{{ r.record.score }}</b> · 共 {{ r.record.totalNum }} 题</div>
            </li>
          </ul>
        </div>

        <!-- 主区 -->
        <div class="rc-main" v-if="active">
          <div class="rm-head">
            <div class="rm-title">
              <i class="el-icon-document-checked"></i>
              答题详情
              <el-tag :type="active.record.passFlag === 1 ? 'success' : 'danger'" effect="dark" size="small">
                {{ active.record.passFlag === 1 ? '已通过' : '未通过' }}
              </el-tag>
            </div>
            <div class="rm-actions">
              <el-button v-if="active.record.passFlag !== 1" type="primary" size="small" @click="goExam">重新答题</el-button>
            </div>
          </div>
          <div class="rm-stat">
            <div><div class="n">{{ active.record.score }}</div><div class="l">得分</div></div>
            <div><div class="n">{{ active.record.totalNum }}</div><div class="l">题目数</div></div>
            <div><div class="n">{{ formatDuration(active.record.duration) }}</div><div class="l">用时</div></div>
            <div><div class="n small">{{ active.record.submitTime ? formatDate(Date.parse(active.record.submitTime), 'YYYY-mm-dd hh:ii') : '--' }}</div><div class="l">提交时间</div></div>
          </div>

          <div class="rm-tip">
            <i class="el-icon-info"></i>
            为保证学习效果，本页仅展示您的作答情况，不公布每题对错与正确答案。如需提升通过率，请认真重看课程视频后再次参加考试。
          </div>

          <div class="rm-list">
            <div class="rm-item" v-for="(d, idx) in active.details" :key="d.id || idx">
              <div class="rm-q-head">
                <span class="rm-no">{{ idx + 1 }}.</span>
                <span class="rm-q">{{ d.question }}</span>
                <el-tag size="mini" :type="d.questionType === 2 ? 'warning' : 'info'">{{ d.questionType === 2 ? '多选' : '单选' }}</el-tag>
              </div>
              <div class="rm-q-img" v-if="d.questionImg">
                <el-image :src="d.questionImg" fit="contain" :preview-src-list="[d.questionImg]">
                  <div slot="error" class="rm-img-err"><i class="el-icon-picture-outline"></i></div>
                </el-image>
              </div>
              <div class="rm-opts">
                <div
                  v-for="opt in buildOptions(d)"
                  :key="opt.k"
                  class="rm-opt"
                  :class="{ 'opt-mine': isInAnswer(d.userAnswer, opt.k) }">
                  <span class="rm-opt-key">{{ opt.k }}.</span>
                  <span class="rm-opt-text">{{ opt.v }}</span>
                  <span class="rm-opt-flag mine" v-if="isInAnswer(d.userAnswer, opt.k)">您的选择</span>
                </div>
              </div>
              <div class="rm-summary">
                您的答案：<b>{{ d.userAnswer || '未作答' }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <xh-footer />
  </div>
</template>

<script>
import XhHeader from '../../../reveals/xh-header.vue'
import XhFooter from '../../../reveals/xh-footer.vue'
import { getStudyUserAllRecords } from '@/service/apis/study'

export default {
  name: 'StudyExamRecord',
  components: { XhHeader, XhFooter },
  data () {
    return {
      account: null,
      courseId: null,
      records: [],   // 该课程的全部记录（已按 submitTime 倒序）
      activeIdx: 0,
      loaded: false
    }
  },
  computed: {
    active () {
      return this.records[this.activeIdx] || null
    },
    activeId () {
      return this.active ? this.active.record.id : 0
    }
  },
  created () {
    const cid = this.$route.query.courseId
    if (!cid) {
      this.$message.error('参数缺失')
      this.$router.replace('/userinfo')
      return
    }
    this.courseId = Number(cid)
    const acct = localStorage.getItem('ACCOUNT')
    if (!acct) {
      this.$router.replace('/login')
      return
    }
    this.account = JSON.parse(acct)
    this.loadAll()
  },
  methods: {
    formatDuration (sec) {
      sec = Math.floor(Number(sec) || 0)
      const h = Math.floor(sec / 3600)
      const m = Math.floor((sec % 3600) / 60)
      const s = sec % 60
      const pad = n => String(n).padStart(2, '0')
      return h > 0 ? `${ pad(h) }:${ pad(m) }:${ pad(s) }` : `${ pad(m) }:${ pad(s) }`
    },
    handle9994 (res) {
      if (res && res.errCode === 9994) {
        localStorage.clear()
        this.$router.replace('/login')
        return true
      }
      return false
    },
    loadAll () {
      getStudyUserAllRecords.call(this, { accountId: this.account.id }).then(res => {
        if (this.handle9994(res)) return
        if (res.errCode === 0 && Array.isArray(res.data)) {
          this.records = res.data.filter(item => item.record && item.record.courseId === this.courseId)
          // 若 query.id 指定，定位到该次
          const targetId = Number(this.$route.query.id)
          if (targetId) {
            const i = this.records.findIndex(r => r.record.id === targetId)
            if (i >= 0) this.activeIdx = i
          }
        }
        this.loaded = true
      })
    },
    select (idx) {
      this.activeIdx = idx
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    buildOptions (d) {
      return ['A', 'B', 'C', 'D']
        .filter(k => d['option' + k])
        .map(k => ({ k, v: d['option' + k] }))
    },
    isInAnswer (answer, k) {
      if (!answer) return false
      return answer.toUpperCase().indexOf(k) >= 0
    },
    optionClass (d, k) {
      const isRight = this.isInAnswer(d.rightAnswer, k)
      const isMine = this.isInAnswer(d.userAnswer, k)
      if (isRight && isMine) return 'opt-right'
      if (isRight) return 'opt-right-only'
      if (isMine) return 'opt-wrong'
      return ''
    },
    goExam () {
      this.$router.push('/study/exam?courseId=' + this.courseId)
    },
    back () {
      this.$router.push('/study/course?id=' + this.courseId)
    }
  }
}
</script>

<style scoped>
.rec-page { background: #fff; }
.container-width { padding: 16px 0 60px; min-height: 60vh; }
.rc-bread {
  font-size: 13px;
  color: #888;
  padding: 6px 0 12px;
}
.rc-bread .mouse:hover { color: #4c2ac9; }

.empty-block {
  text-align: center;
  color: #999;
  padding: 80px 20px;
  font-size: 14px;
}

.rc-layout {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}
.rc-side {
  width: 240px;
  flex-shrink: 0;
  border: solid 1px #ece8ff;
  border-radius: 8px;
  position: sticky;
  top: 16px;
  max-height: 80vh;
  overflow-y: auto;
}
.rc-side-head {
  font-size: 14px;
  font-weight: 600;
  color: #2e2e2e;
  padding: 12px 14px;
  background: #faf8ff;
  border-bottom: solid 1px #f0ebff;
}
.rc-list { padding: 4px 0; }
.rc-list li {
  padding: 12px 14px;
  border-bottom: solid 1px #f5f5f5;
  cursor: pointer;
  transition: background .15s;
}
.rc-list li:hover { background: #faf8ff; }
.rc-list li.on { background: #f3eeff; }
.rc-list li:last-child { border-bottom: none; }
.rl-row { display: flex; justify-content: space-between; align-items: center; }
.rl-no { font-size: 13px; color: #4c2ac9; font-weight: 600; }
.rl-time { font-size: 12px; color: #999; margin-top: 4px; }
.rl-score { font-size: 12px; color: #666; margin-top: 4px; }
.rl-score b { color: #4c2ac9; }

.rc-main { flex: 1; min-width: 0; }
.rm-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: solid 1px #ece8ff;
  border-radius: 8px;
  padding: 12px 18px;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #faf8ff 0%, #fff 60%);
}
.rm-title { font-size: 16px; color: #2e2e2e; font-weight: 600; }
.rm-title i { color: #4c2ac9; margin-right: 6px; }
.rm-title .el-tag { margin-left: 10px; }
.rm-stat {
  display: flex;
  border: solid 1px #ece8ff;
  border-radius: 8px;
  padding: 16px 0;
  margin-bottom: 12px;
}
.rm-stat > div {
  flex: 1;
  text-align: center;
  border-right: solid 1px #f0ebff;
}
.rm-stat > div:last-child { border-right: none; }
.rm-stat .n {
  font-size: 22px;
  color: #4c2ac9;
  font-weight: 600;
  line-height: 30px;
}
.rm-stat .n.small { font-size: 14px; line-height: 30px; }
.rm-stat .n.green { color: #4caf50; }
.rm-stat .n.red { color: #f56c6c; }
.rm-stat .l { font-size: 12px; color: #999; }

.rm-list {
  border: solid 1px #f0f0f0;
  border-radius: 8px;
  padding: 6px 0;
}
.rm-tip {
  font-size: 13px;
  color: #b35c00;
  background: #fff7e6;
  padding: 10px 14px;
  border-radius: 6px;
  line-height: 22px;
  margin-bottom: 12px;
}
.rm-tip i { margin-right: 4px; }
.rm-item {
  padding: 18px 22px;
  border-bottom: solid 1px #f5f5f5;
}
.rm-item:last-child { border-bottom: none; }
.rm-q-head {
  font-size: 15px;
  color: #2e2e2e;
  line-height: 24px;
  margin-bottom: 12px;
}
.rm-no { color: #4c2ac9; font-weight: 600; margin-right: 6px; }
.rm-q-head .el-tag { margin-left: 8px; }
.rm-q-head .right-tag { float: right; }

.rm-q-img {
  margin: 0 0 14px;
  max-width: 360px;
}
.rm-q-img .el-image {
  width: 100%;
  max-height: 260px;
  border-radius: 6px;
  border: solid 1px #f0f0f0;
}
.rm-q-img .rm-img-err {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  color: #ddd;
  font-size: 28px;
}

.rm-opts { padding-left: 8px; }
.rm-opt {
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 6px;
  font-size: 14px;
  color: #555;
  background: #fafafa;
  display: flex;
  align-items: center;
}
.rm-opt-key { color: #888; font-weight: 600; margin-right: 8px; }
.rm-opt-text { flex: 1; }
.rm-opt-flag {
  font-size: 12px;
  color: #4caf50;
  margin-left: 8px;
  padding: 1px 8px;
  background: rgba(76, 175, 80, .1);
  border-radius: 10px;
}
.rm-opt-flag.mine {
  color: #4c2ac9;
  background: rgba(76, 42, 201, .1);
}
.rm-opt.opt-mine {
  background: rgba(76, 42, 201, .08);
  border: solid 1px rgba(76, 42, 201, .25);
}
.rm-opt.opt-mine .rm-opt-key { color: #4c2ac9; }

.rm-summary {
  margin-top: 10px;
  padding: 8px 12px;
  font-size: 13px;
  color: #666;
  background: #fafafa;
  border-radius: 4px;
}
.rm-summary .sep { margin: 0 10px; color: #ddd; }
.rm-summary .green { color: #4caf50; }
.rm-summary .red { color: #f56c6c; }

@media screen and (max-width: 800px) {
  .container-width { padding: 8px 16px 30px; }
  .rc-layout { flex-direction: column; }
  .rc-side {
    width: 100%;
    max-height: 240px;
    position: static;
  }
  .rm-stat { flex-wrap: wrap; padding: 8px 0; }
  .rm-stat > div {
    flex: 0 0 33.33%;
    border-right: none;
    padding: 6px 0;
  }
  .rm-stat .n { font-size: 18px; }
  .rm-item { padding: 14px 14px; }
  .rm-q-head { font-size: 14px; }
  .rm-q-head .right-tag { float: none; margin-top: 6px; }
}
</style>
